export const storageDocumentsPath = {
  visaDocuments: "documents"
};
